import React from "react";
import ReactApexChart from "react-apexcharts";

const TopSellsAgenciesChart = ({
  series = [],
  categories = [],
  companyCount = 0,
  height = 420,
  isLoading = false,
  companyRange,
  setCompanyRange,
}) => {
  const processedSeries = series.map(({ name, data }) => ({
    name,
    data: data.map((value) => (value === 0 ? null : value)),
  }));

  const generateRangeOptions = () => {
    const options = [];
    for (let i = 1; i <= companyCount; i += 10) {
      const start = i;
      const end = Math.min(i + 10 - 1, companyCount);
      options.push({ start, end, label: `${start}-${end}` });
    }
    return options;
  };

  const rangeOptions = generateRangeOptions();

  const handleRangeChange = (event) => {
    const selectedOption = rangeOptions.find(
      (option) => option.label === event.target.value
    );
    if (selectedOption) {
      setCompanyRange({ start: selectedOption.start, end: selectedOption.end });
    }
  };

  const options = {
    chart: {
      type: "bar",
      stacked: false,
      toolbar: { show: false },
    },
    colors: [
      "#E53935",
      "#1E90FF",
      "#43A047",
      "#8E24AA",
      "#00ACC1",
      "#FFA000",
      "#009688",
      "#795548",
      "#607D8B",
      "#C2185B",
      "#2B1FA2",
      "#FBC02D",
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "80%",
      },
    },
    dataLabels: { enabled: false },
    stroke: { show: true, width: 1, colors: ["transparent"] },
    xaxis: {
      categories: categories.map((category) =>
        category.split(" ").slice(0, 2).join(" ")
      ),
      // categories: categories,
      tickAmount: 10,
      labels: { rotate: -45, style: { fontSize: "11px" } },
      tickPlacement: "on",
    },
    yaxis: {
      labels: {
        formatter: (val) => (val != null ? Number(val).toLocaleString() : ""),
      },
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
      markers: { radius: 12 },
    },
    grid: {
      borderColor: "#EBEBEB",
      strokeDashArray: 6,
      padding: {
        left: 70,
        right: 40,
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (val) => (val != null ? Number(val).toLocaleString() : ""),
      },
    },
    responsive: [
      {
        breakpoint: 992,
        options: {
          plotOptions: { bar: { columnWidth: "70%" } },
          xaxis: { labels: { rotate: -45 } },
        },
      },
      {
        breakpoint: 576,
        options: {
          plotOptions: { bar: { columnWidth: "80%" } },
          xaxis: { labels: { rotate: -60 } },
        },
      },
    ],
  };

  if (isLoading) {
    return (
      <div className="card">
        <div className="border-0 card-header d-sm-flex d-block">
          <div className="mb-3 me-auto mb-sm-0">
            <h4 className="mb-2 card-title">Top Selling Agencies</h4>
          </div>
        </div>
        <div className="card-body" style={{ height }}>
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="border-0 card-header d-sm-flex d-block">
        <div className="mb-3 me-auto mb-sm-0">
          <h4 className="mb-2 card-title">Top Selling Agencies</h4>
        </div>
        {companyCount > 10 && (
          <div className="gap-3 mb-3 d-flex mb-sm-0">
            <div>
              <label className="mb-1 form-label small">Companies:</label>
              <select
                className="form-select form-select-sm"
                value={`${companyRange.start}-${companyRange.end}`}
                onChange={handleRangeChange}
                style={{ minWidth: "120px" }}
              >
                {rangeOptions.map((option) => (
                  <option key={option.label} value={option.label}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}
      </div>
      <div className="card-body">
        <ReactApexChart
          options={options}
          series={processedSeries}
          type="bar"
          height={height}
        />
      </div>
    </div>
  );
};

export default TopSellsAgenciesChart;
